exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enabled-button {\n  color: #4b81b0; }\n\n.disabled-button {\n  color: #9e9e9e; }\n\n.outline-none:focus {\n  outline: none; }\n\n.sub-divider {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 10px; }\n  .sub-divider span {\n    font-size: 12px;\n    color: #afafaf; }\n  .sub-divider div {\n    width: 100%;\n    margin: 9px 0 0 5px;\n    border-bottom: 1px solid #cecece;\n    height: 0; }\n\n.error-message {\n  font-size: 12px;\n  color: #E55049;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/entidades-financieras/new-entidad-dialog/new-entidad-dialog.component.scss
// module id = ../../../../../src/app/components/abm/entidades-financieras/new-entidad-dialog/new-entidad-dialog.component.scss
// module chunks = 0